export const flattenSchemaInputs = (inputs, allVariants) => {
  const flattened = [];

  // Sort inputs by group_level1 first, then by table_order within each group
  const sortedInputs = Object.values(inputs).sort((a, b) => {
    // First sort by group_level1 (primary grouping)
    const group1Compare =
      parseInt(a.group_level1 || "999") - parseInt(b.group_level1 || "999");
    if (group1Compare !== 0) {
      return group1Compare;
    }
    // Then sort by table_order within the same group
    return parseInt(a.table_order || 999) - parseInt(b.table_order || 999);
  });

  sortedInputs.forEach((table) => {
    const group2 = table.group_level2 || "Ungrouped";

    flattened.push({
      table_id: table.table_id,
      table_name: table.table_name,
      table_description: table.table_description,
      group_level2: group2, // Keep this for backward compatibility with existing components
      group_level1: table.group_level1,
      table_order: table.table_order,
      table_status: table.table_ready || "empty", // Add table_ready as table_status
      variants: allVariants[table.table_id] || [],
    });
  });
  return flattened;
};
